module.exports = __webpack_public_path__ + "img/exception_404.16be44eb.png";